import { api } from '../api';
import type { PackContainer, Uom } from '@/types/material-conversion';

export interface UomQueryParams {
  type?: 'WEIGHT' | 'LIQUID' | 'EACH';
  /** Only units a supplier sells in. */
  pack?: boolean;
  /** Only units a recipe line can measure in. */
  recipe?: boolean;
  /** Only volumes used to weigh for density. */
  densityRef?: boolean;
}

function buildQueryString(params?: UomQueryParams): string {
  if (!params) return '';
  const sp = new URLSearchParams();
  if (params.type) sp.set('type', params.type);
  if (params.pack !== undefined) sp.set('pack', String(params.pack));
  if (params.recipe !== undefined) sp.set('recipe', String(params.recipe));
  if (params.densityRef !== undefined) sp.set('densityRef', String(params.densityRef));
  const qs = sp.toString();
  return qs ? `?${qs}` : '';
}

/**
 * The fixed unit reference tables behind every UoM dropdown ("UoM Reference
 * Tables", tables 1–4) — read-only, safe to cache for the whole session.
 */
export const uomReferenceApi = {
  getUoms: (params?: UomQueryParams) => api.get<Uom[]>(`/units/uoms${buildQueryString(params)}`),
  getPackContainers: () => api.get<PackContainer[]>('/units/pack-containers'),
};
